
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Signal, Clock, Wifi, Database, RefreshCw } from 'lucide-react';

interface NetworkInformationProps {
  device: any;
  isSmartMeter: boolean;
}

const NetworkInformation: React.FC<NetworkInformationProps> = ({ device, isSmartMeter }) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Network Information</CardTitle>
      </CardHeader>
      <CardContent>
        {isSmartMeter ? (
          <div className="space-y-4">
            <div className="flex justify-between">
              <div className="flex items-center">
                <Signal className="h-4 w-4 mr-2 text-muted-foreground" />
                <span className="text-sm font-medium">Signal Strength</span>
              </div>
              <span className="text-sm">{device.signalStrength}%</span>
            </div>
            <div className="flex justify-between">
              <div className="flex items-center">
                <Clock className="h-4 w-4 mr-2 text-muted-foreground" />
                <span className="text-sm font-medium">Last Communication</span>
              </div>
              <span className="text-sm">{new Date(device.lastCommunication).toLocaleString()}</span>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="flex justify-between">
              <div className="flex items-center">
                <Wifi className="h-4 w-4 mr-2 text-muted-foreground" />
                <span className="text-sm font-medium">Connectivity Type</span>
              </div>
              <span className="text-sm">{device.networkStatus.connectivityType}</span>
            </div>
            <div className="flex justify-between">
              <div className="flex items-center">
                <Signal className="h-4 w-4 mr-2 text-muted-foreground" />
                <span className="text-sm font-medium">Signal Strength</span>
              </div>
              <span className="text-sm">{device.networkStatus.signalStrength}%</span>
            </div>
            <div className="flex justify-between">
              <div className="flex items-center">
                <Database className="h-4 w-4 mr-2 text-muted-foreground" />
                <span className="text-sm font-medium">Data Transferred</span>
              </div>
              <span className="text-sm">{device.networkStatus.dataTransferred.toFixed(1)} MB</span>
            </div>
            <div className="flex justify-between">
              <div className="flex items-center">
                <RefreshCw className="h-4 w-4 mr-2 text-muted-foreground" />
                <span className="text-sm font-medium">Last Ping Time</span>
              </div>
              <span className="text-sm">{device.networkStatus.lastPingTime} ms</span>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default NetworkInformation;
